import * as React from 'react';

import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import styled from 'styled-components';

import SliderArrowIcon from '@components/basics/icons/slider-arrow';

interface ArtistSelectorSwiperProps {
  id: string;
  className?: string;
  children: React.ReactElement[];
  slidesLength?: number;
}

const ArtistSelectorSwiper: React.FC<ArtistSelectorSwiperProps> = ({
  slidesLength,
  ...props
}) => {
  const [swiper, setSwiper] = React.useState<any>(null);
  const [activeIndex, setActiveIndex] = React.useState<number>(0);
  // const [canSlideNext, setCanSlideNext] = React.useState<boolean>();

  const params = {
    spaceBetween: 40,
    slidePerView: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 24,
    grabCursor: true,
    allowTouchMove: true,
    navigation: true,
  };

  const initSwiper = (instance: any) => {
    if (instance) {
      instance.on('slideChange', () => setActiveIndex(instance.activeIndex));
      slideTo(0);
    }
    setSwiper(instance);
  };

  const slideTo = (index: number) => {
    if (swiper) {
      swiper.slideTo(index);
    }
  };

  const slidePrev = () => {
    if (swiper) {
      swiper.slidePrev();
    }
  };

  const slideNext = () => {
    if (swiper && (slidesLength ? activeIndex + 1 < slidesLength : false)) {
      swiper.slideNext();
    }
  };

  const canSlidePrev = () => {
    if (swiper) {
      return activeIndex === 0;
    }
    return false;
  };

  // TODO: Integrate CanSlideNext when there are no more slides.
  // React.useEffect(() => {
  //   if (swiper && slidesLength) {
  //     if (activeIndex + 1 < slidesLength) {
  //       setCanSlideNext(true);
  //     }
  //   }
  // }, [props.children, swiper, activeIndex, slidesLength]);

  return (
    <div className={props.className}>
      <SliderArrowIcon
        className="arrow"
        onClick={() => slidePrev()}
        arrowDirection="left"
        disabled={canSlidePrev()}
        circularBg
      />
      {slidesLength && slidesLength > 0 ? (
        <Swiper {...params} getSwiper={initSwiper}>
          {props.children}
        </Swiper>
      ) : null}
      <SliderArrowIcon
        className="arrow"
        onClick={() => slideNext()}
        arrowDirection="right"
        // disabled={canSlideNext}
        circularBg
      />
    </div>
  );
};

export default styled(ArtistSelectorSwiper)`
  width: 100%;
  max-width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;

  .swiper-container {
    margin: 0;
  }
`;
